(function () {
  'use strict';

  /* @ngdoc object
   * @name flightBlockTimeReport
   * @description
   *
   */
  angular
    .module('flightBlockTimeReport', [
      'ui.router'
    ]);
}());
